import { c as _c } from "react/compiler-runtime";
import { type AlertProps, Alert as BaseAlert } from '@shared/ui-components/alert/alert';
import { useGlobalCmsContentContext } from '../providers/global-cms-context';
export const Alert = props => {
  const $ = _c(3);
  const {
    cmsContent
  } = useGlobalCmsContentContext();
  let t0;
  if ($[0] !== cmsContent.closeButtonLabel || $[1] !== props) {
    t0 = <BaseAlert {...props} closeButtonLabel={cmsContent.closeButtonLabel} />;
    $[0] = cmsContent.closeButtonLabel;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};